import { render, staticRenderFns } from "./WebsiteEnd.vue?vue&type=template&id=983c940e&scoped=true"
import script from "./WebsiteEnd.vue?vue&type=script&lang=js"
export * from "./WebsiteEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983c940e",
  null
  
)

export default component.exports